<script lang="ts">
    export let title: string;
    export let description: string = '';
    export let imageUrl: string = '';
</script>

<svelte:head>
    {#if title}
        <!-- Primary Meta Tags -->
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={description} />

        <!-- Open Graph / Facebook -->
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {#if imageUrl}
            <meta property="og:image" content={imageUrl} />
        {/if}

        <!-- Twitter -->
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        {#if imageUrl}
            <meta property="twitter:image" content={imageUrl} />
        {/if}
    {/if}
</svelte:head>
